module.exports = __webpack_public_path__ + "media/images/KVL_Ball-02-8ce195c418c1f7431afcb0f55f8ef8dd.svg";